export const ARENA_NAME_MAPPING: { [key: string]: string } = {
  'HARD': 'Хард первый корпус',
  'HARD1': 'Хард первый корпус',
  'HARD2': 'Хард второй корпус',
  'Padel': 'Padel',
  'PADEL': 'Padel',
  'Padel (улица)': 'Padel (улица)',
  'Хард, первый корпус': 'Хард первый корпус',
  'Хард, второй корпус': 'Хард второй корпус',
};

export const ARENA_SORT_ORDER: { [key: string]: number } = {
  'Хард первый корпус': 1,
  'Хард второй корпус': 2,
  'Padel': 3,
  'Padel (улица)': 4,
  'Стенка': 5,
  'Залы': 6,
};

export function formatArenaName(originalName: string): string {
  const normalizedName = originalName.trim();
  
  if (ARENA_NAME_MAPPING[normalizedName]) {
    return ARENA_NAME_MAPPING[normalizedName];
  }
  
  const lowerName = normalizedName.toLowerCase();
  
  if (lowerName.includes('хард') || lowerName.includes('hard')) {
    if (lowerName.includes('второй') || lowerName.includes('2') || lowerName.includes('second') || lowerName.includes('второй корпус')) {
      return 'Хард второй корпус';
    }
    if (lowerName.includes('первый') || lowerName.includes('1') || lowerName.includes('first') || lowerName.includes('первый корпус')) {
      return 'Хард первый корпус';
    }
    return 'Хард первый корпус';
  }
  
  if (lowerName.includes('padel')) {
    if (lowerName.includes('улиц')) {
      return 'Padel (улица)';
    }
    return 'Padel';
  }
  
  return originalName;
}

export function sortArenas<T extends { title: string }>(arenas: T[]): T[] {
  return [...arenas].sort((a, b) => {
    const titleA = a.title;
    const titleB = b.title;
    
    const orderA = ARENA_SORT_ORDER[titleA] ?? 999;
    const orderB = ARENA_SORT_ORDER[titleB] ?? 999;
    
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    
    return titleA.localeCompare(titleB);
  });
}

export function sortArenaTitles(titles: string[]): string[] {
  return [...titles].sort((a, b) => {
    const titleA = a;
    const titleB = b;
    
    const orderA = ARENA_SORT_ORDER[titleA] ?? 999;
    const orderB = ARENA_SORT_ORDER[titleB] ?? 999;
    
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    
    return titleA.localeCompare(titleB);
  });
}
